import { VStack } from '@chakra-ui/layout'
import React from 'react'

const SettingsToggleBox = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[]
}): React.ReactElement => (
  <VStack
    px={8}
    py={6}
    background="#fbfcff"
    width="100%"
    justifyContent="flex-start"
    alignItems="flex-start"
    spacing="1em"
  >
    {children}
  </VStack>
)

export default SettingsToggleBox
